import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "referrals section section--mini" }
const _hoisted_2 = { class: "referral__icon" }
const _hoisted_3 = {
  key: 0,
  class: "referral__name"
}
const _hoisted_4 = {
  key: 1,
  class: "referral__name"
}
const _hoisted_5 = {
  class: "referral__amount",
  "data-currency": "USDT"
}

import "./ReferralsView.scss";
import {computed, onMounted, ref, watch} from "vue";
import ReferralRewardEntity from "@/entities/ReferralEntity";
import Icon from "@/components/Icon/Icon.vue";
import {useApiStore} from "@/stores/apiStore";
import BalanceHistoryEntity from "@/entities/BalanceHistoryEntity";

interface Props{
	orderBy : 'asc' | 'desc'
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ReferralView',
  props: {
    orderBy: { default: 'desc' }
  },
  setup(__props: any) {

let {api} = useApiStore();

let props = __props;

let items = ref<BalanceHistoryEntity[]>([]);
let loading = ref<boolean>(false);

async function loadReferrals(){

	loading.value = true;

	let referrals = await api.getReferrals(1, 100, {
		mode : props.orderBy,
		field : 'id'
	}, {
		type : 'referral'
	});

	items.value = referrals.items;
	loading.value = false;

}

onMounted(loadReferrals);
watch(() => props.orderBy, loadReferrals);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (item) => {
      return (_openBlock(), _createElementBlock("article", {
        class: "referrals__item referral card",
        key: item.id
      }, [
        _createElementVNode("i", _hoisted_2, [
          _createVNode(Icon, { name: "mail" })
        ]),
        (item.referral_user.username)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "@" + _toDisplayString(item.referral_user.username), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(item.referral_user.name), 1)),
        _createElementVNode("span", _hoisted_5, "+" + _toDisplayString(item.amount.toFixed(2)), 1)
      ]))
    }), 128))
  ]))
}
}

})